"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictionRuleCategoryMutuallyExclusive = void 0;
const _1 = require("./");
const cloneModelObject_1 = require("../../../../../apis/spg/util/cloneModelObject");
/**
 * Restriction Rule: CategoryMutuallyExclusive
 *
 * This rule restricts the selection of items in a category to others.
 * Only one item in the list of products can be selected at once
 */
class RestrictionRuleCategoryMutuallyExclusive {
    constructor(data) {
        this.name = _1.TRestrictionRuleName.categoryMutuallyExclusive;
        if (data) {
            this.category = data.category;
            this.productIds = data.productIds;
            this.min = data.min;
            this.max = data.max;
        }
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            name: this.name,
            category: this.category,
            productIds: this.productIds,
            min: this.min,
            max: this.max
        };
    }
    static unserialize(data) {
        const newRestrictionRuleMutuallyExclusive = new this();
        newRestrictionRuleMutuallyExclusive.category = data.category;
        newRestrictionRuleMutuallyExclusive.productIds = data.productIds;
        newRestrictionRuleMutuallyExclusive.min = data.min;
        newRestrictionRuleMutuallyExclusive.max = data.max;
        return newRestrictionRuleMutuallyExclusive;
    }
    isValid(products, productAvailability, selectedProducts) {
        const productSelected = this._getProductSelected(selectedProducts);
        const { min, max } = this;
        // rule is valid if there is no product selected and no selection is required
        if (productSelected === undefined) {
            return min === 0;
        }
        const { product: { productId }, quantity } = productSelected;
        const otherProductSelected = this._getOtherProductSelected(selectedProducts, productId);
        // if another product is selected then it isn't exclusive and therefore not valid
        if (otherProductSelected !== undefined) {
            return false;
        }
        // otherwise rule is valid if the quantity is within the allowed selection range
        return quantity >= min && quantity <= max;
    }
    apply(products, productAvailability, selectedProducts) {
        const productSelected = this._getProductSelected(selectedProducts);
        // if no product is selected then there's nothing to do
        if (productSelected === undefined) {
            return;
        }
        const { product: { productId } } = productSelected;
        // update the state of the product selected in this rule of whether they can be added or removed
        this._updateCanAddRemove(productAvailability, productSelected);
        const otherProductSelected = this._getOtherProductSelected(selectedProducts, productId);
        // if no other product is selected then there's nothing to do
        // this becomes available on changing selection
        if (otherProductSelected === undefined) {
            return;
        }
        // update the state of the other product selected in this rule of whether they can be added or removed
        this._updateCanAddRemove(productAvailability, otherProductSelected);
        // since another product has been selected we remove the current selected product
        this._removeFromProductSelections(selectedProducts, productId);
    }
    /**
     * Get the current selected product in this category
     */
    _getProductSelected(selectedProducts) {
        return selectedProducts.find((selectedProduct) => this.productIds.indexOf(selectedProduct.product.productId) !== -1 &&
            selectedProduct.product.category.name === this.category &&
            selectedProduct.quantity > 0);
    }
    /**
     * All products ids that are not currently selected
     */
    _getNotSelectedProductIds(selectedProductId) {
        return this.productIds.filter((productId) => productId !== selectedProductId);
    }
    /**
     * Get the other product that has now been selected from the previous one that was
     */
    _getOtherProductSelected(selectedProducts, productSelectedId) {
        return selectedProducts.find((selectedProduct) => selectedProduct.product.productId !== productSelectedId &&
            selectedProduct.product.category.name === this.category);
    }
    /**
     * Update the state of whether the selected product can be added or removed
     */
    _updateCanAddRemove(productAvailabilities, productSelected) {
        const { product: { productId } } = productSelected;
        const { min, max } = this;
        productAvailabilities.map((productAvailability) => {
            // this selected product can be:
            //  - removed: current selected quantity greater than the minimum
            //  - added: current selected quantity is let than the maximum
            if (productId === productAvailability.productId) {
                productAvailability.canRemove = productSelected.quantity > min;
                productAvailability.canAdd = productSelected.quantity < max;
            }
            // all other products that that are not currently selected can be added but not removed
            const otherNotSelectedProductIds = this._getNotSelectedProductIds(productId);
            if (otherNotSelectedProductIds.includes(productAvailability.productId)) {
                productAvailability.canRemove = false;
                productAvailability.canAdd = true;
            }
        });
    }
    /**
     * Remove a given product's selection
     */
    _removeFromProductSelections(selectedProducts, productSelectedId) {
        selectedProducts.map((selectedProduct, index) => {
            if (selectedProduct.product.productId === productSelectedId) {
                selectedProducts.splice(index, 1);
            }
        });
    }
}
exports.RestrictionRuleCategoryMutuallyExclusive = RestrictionRuleCategoryMutuallyExclusive;
//# sourceMappingURL=RestrictionRuleCategoryMutuallyExclusive.js.map